import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { useContext } from "react";
import { ButtonContext } from "../context";
import styles from "./button-icon.module.css";
const ButtonIcon = (props) => {
    const { className, ...otherProps } = props;
    const { size, variant } = useContext(ButtonContext);
    return (_jsx("div", { className: clsx(styles.button_icon, className), "data-variant": variant, "data-size": size, ...otherProps }));
};
export { ButtonIcon };
